export default {
    init() {
        // JavaScript to be fired on the What's New page
        function masonryNews() {
            $('.news-stories .visc-posts-list > .row').imagesLoaded(
                function () {
                    $('.news-stories .visc-posts-list > .row').masonry({
                        // options
                        itemSelector: '.col',
                    });
                }
            );
        }

        masonryNews();

        $(document).on('visceralPosts:ajaxSuccess', () => {
            masonryNews();
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/news-stories.js